import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExtensionUninstalledPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ExtensionUninstalledPage" */ './Container'),
  'page'
);
